// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__os-9r","searchText":"App_searchText__nNBus"};